import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, propTypes as formPropTypes } from 'redux-form';
import cloneDeep from 'lodash/cloneDeep';
import ReduxFormField from '../../common/forms/ReduxFormsField';
import TwoStepButton from '../../common/components/TwoStepButton';
import CropperScaffold from '../../common/forms/CropperScaffold';
import ReduxFormsImageCropper from '../../common/forms/ReduxFormsImageCropper';

const validate = values => {
  const errors = {};
  const { name, description } = values;

  if (!name || !name.trim()) {
    errors.name = ['Name is required'];
  } else if (name.trim().length > 255) {
    errors.name = ['Name cannot be longer than 255 characters'];
  }

  if (!description || !description.trim()) {
    errors.description = ['Description is required'];
  } else if (description.trim().length > 255) {
    errors.description = ['Description cannot be longer than 255 characters'];
  }

  return errors;
};

class TvShowEditForm extends Component {
  static propTypes = {
    ...formPropTypes,
    clearOrigImage: PropTypes.bool,
    onCancel: PropTypes.func,
    onDelete: PropTypes.func,
    removeImage: PropTypes.func,
    show: PropTypes.object,
  };

  onSubmit = values => {
    const submitValues = cloneDeep(values);
    submitValues.name = submitValues.name.trim();
    submitValues.description = submitValues.description.trim();

    return this.props.onSubmit(submitValues);
  };

  render() {
    const { clearOrigImage, handleSubmit, onCancel, onDelete, removeImage, show, submitting } = this.props;

    return (
      <div className="admin-paper__edit-content">
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <Field name="name" component={ReduxFormField} label="Show Name" required={true}>
            <input type="text" />
          </Field>
          <Field name="description" component={ReduxFormField} label="Show Description" required={true}>
            <input type="text" />
          </Field>
          {show && show.get('image_id') && !clearOrigImage ? (
            <CropperScaffold label="Show Image" required>
              <div className="original-image">
                <img alt="show logo" src={show.getIn(['image', 'location'])} />
              </div>
              <div className="cropper-scaffold__controls">
                <button type="button" className="button button--theme--outline" onClick={removeImage}>
                  Remove Image
                </button>
              </div>
            </CropperScaffold>
          ) : (
            <Field name="image" component={ReduxFormsImageCropper} label="Show Image" />
          )}
          <div className="admin-paper__edit-content__button-row">
            <div>
              <TwoStepButton onConfirm={onDelete} disabled={submitting} buttonText="Delete Show" />
            </div>
            <div>
              <button type="button" className="button button--theme--plain" onClick={onCancel} disabled={submitting}>
                Cancel
              </button>
              <button type="submit" className="button" disabled={submitting}>
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'tvShowEditForm',
  onSubmitFail: () => {
    window.scrollTo(0, 0);
  },
  validate,
})(TvShowEditForm);



// WEBPACK FOOTER //
// ./src/tv/shows/TvShowEditForm.js